import { render, staticRenderFns } from "./AgencyManage.vue?vue&type=template&id=14c98280&scoped=true&"
import script from "./AgencyManage.vue?vue&type=script&lang=js&"
export * from "./AgencyManage.vue?vue&type=script&lang=js&"
import style0 from "./AgencyManage.vue?vue&type=style&index=0&id=14c98280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c98280",
  null
  
)

export default component.exports